AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track, trackUe, Verb, Noun } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopover, replaceAssignInputValue } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopover, replaceDueInputValue } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
urls = require 'app/scripts/controller/urls'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
{ avatarDomain } = require '@trello/config'
Layout = require 'app/scripts/views/lib/layout'
{ getAssigneeUsername, getDueDate, trackNameChange, trackNameRender } = require './check-item-name'
{ hasAdvancedChecklistsBeta, hasAdvancedChecklistsV2, hasUpsell, shouldShowEditModeButtons } = require './has-advanced-checklists'

viewTitle = forNamespace('view title')

template = t.renderable ({ editable, showSetDueDateButton, showAssignButton }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.span '.checklist-item-assignee.js-checklist-item-assignee.hide-on-edit'
      t.span '.checklist-item-text-and-due.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.span '.checklist-item-due.js-checklist-item-due'
      if editable
        t.div '.edit.options-menu', { class: t.classify({ assign: showAssignButton, due: showSetDueDateButton }) }, ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

    if editable
      t.div '.checklist-item-menu-wrapper.hide-on-edit', ->
        t.div '.checklist-item-menu.js-open-menu', ->
          t.span '.icon-sm.icon-overflow-menu-horizontal'

assigneeTemplate = t.renderable ({ member }) ->
  if member
    t.button '.subtle.js-open-assign-selector-no-edit', ->
      t.div '.member.m-member-mod-24', ->
        memberAvatarTemplate(member)

dueTemplate = t.renderable (due, className) ->
  if due
    t.button '.subtle.js-open-due-selector-no-edit', { class: className }, ->
      t.icon 'clock'
      if due
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends EditableView
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
    super

  events:
    'keyup .js-checkitem-input': 'keyAutoMention'
    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'
    'movecheckitem': 'moveCheckItem'

    # Advanced Checklists
    'click .js-open-assign-selector': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (value) => replaceAssignInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking member button in edit checkitem view'
      })

    'click .js-open-assign-selector-no-edit': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking member in assign member popover')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking member button in checkitem view'
      })

    'click .js-open-due-selector': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (value) => replaceDueInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking due date button in edit checkitem view'
      })

    'click .js-open-due-selector-no-edit': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking a submit button in due date picker')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking due date badge in checkitem view'
      })

  dueDateUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod, billingUrl }) ->
    if hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
      toggleDatePopover({
        title: viewTitle('change due date') + ' (Beta)',
        setValue,
        getInitialValue,
        trackingMethod,
      })(e)
    else if hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())
      Util.stop(e)
      console.log('clicked due date badge') # TODO toggleDatePopover using model's `due` field
    else if hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking due date button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  assignUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod }) ->
    if hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
      toggleAssignPopover({
        setValue
        getInitialValue
        title: viewTitle('assign') + ' (Beta)'
        getCardMembers: => @model.getCard().memberList.toJSON()
        getBoardMembers: => @model.getBoard().memberList.filterDeactivated(force: true).toJSON()
        trackingMethod
      })(e)
    else if hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())
      Util.stop(e)
      console.log('clicked member avatar') # TODO toggleAssignePopover using model's `idMember` field
    else if hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking member button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  getCard: -> @model.getCard()

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  advancedCheckItemFromModel: ->
    return {
      name: @model.get('name'),
      validAssigneeUsernames: @model.getBoard().memberList.map((member) -> member.get('username'))
      orgProductNumber: @model.getBoard()?.getOrganization()?.getProduct()
    }

  render: ->
    view = @
    model = @model

    _shouldShowEditModeButtons = shouldShowEditModeButtons(@model.getBoard()?.getOrganization()?.getProduct())
    editable = @model.editable()

    @$el.html(
      template({
        showAssignButton: editable && _shouldShowEditModeButtons
        showSetDueDateButton: editable && _shouldShowEditModeButtons
        editable: editable
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallDrafts()

    trackNameRender(@advancedCheckItemFromModel())

    @

  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  renderAssignee: ->
    _hasAdvancedChecklistsBeta = hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
    _hasAdvancedChecklistsV2 = hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())

    if !(_hasAdvancedChecklistsBeta || _hasAdvancedChecklistsV2)
      return

    member =
      if _hasAdvancedChecklistsV2
        @model.getBoard().memberList.find((member) => member.id == @model.get('idMember'))
      else if _hasAdvancedChecklistsBeta
        assigneeUsername = getAssigneeUsername(@advancedCheckItemFromModel())
        assigneeUsername && @model.getBoard().memberList.find((member) -> member.get('username') == assigneeUsername)

    @$('.js-checklist-item-assignee').html(assigneeTemplate({
      member: member?.toJSON()
    }))
    .toggleClass('no-assignee', !member?)
    return

  renderDue: ->
    _hasAdvancedChecklistsBeta = hasAdvancedChecklistsBeta(@model.getBoard()?.getOrganization()?.getProduct())
    _hasAdvancedChecklistsV2 = hasAdvancedChecklistsV2(@model.getBoard()?.getOrganization()?.getProduct())

    if !(_hasAdvancedChecklistsBeta || _hasAdvancedChecklistsV2)
      return

    due =
      if _hasAdvancedChecklistsV2
        @model.get('due')
      else if _hasAdvancedChecklistsBeta
        getDueDate(@advancedCheckItemFromModel())

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        if _hasAdvancedChecklistsV2
          DueDateHelpers.classForDueDate(moment(due).toDate(), complete)
        else if _hasAdvancedChecklistsBeta
          # Beta only embeds a date (no time/timezone) in the checkItem text.
          # Add one day so it appears overdue at 11:59pm that day in the viewing
          # user's timezone. V2 just relies on the server-side timestamp.
          DueDateHelpers.classForDueDate(moment(due).add(1, 'days').toDate(), complete)
      else
        ""

    @$('.js-checklist-item-due').html(dueTemplate(dueText, className))
    .toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  commitEdits: (e) ->
    PopOver.hide()
    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      prevName = @model.get('name')
      super
      trackNameChange(@advancedCheckItemFromModel(), prevName, 'by clicking save button in edit checkitem view')

  _setName: (newName, trackingMethod) ->
    prevName = @model.get('name')
    newName = newName.trim()

    if newName.length == 0
      @model.destroy()
      trackUe('card detail', 'removes', 'checklist item', '', '', trackingMethod)
    else
      # Update the textarea value as well, so that we don't save a draft
      # of the old value.
      textarea = @$('.field')
      if textarea?.val() == prevName
        textarea?.val(newName)

      @model.update('name', newName)
      trackNameChange(@advancedCheckItemFromModel(), prevName, trackingMethod)


  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true
